<template>
  <span :class="classes">
    <SvgIcon :name="icon" :size="iconSize" />
  </span>
</template>

<script lang="ts" setup>
import './RoundIcon.scss';
import { computed } from 'vue';
import SvgIcon from 'ewi-ui/components/1-atoms/Icon/SvgIcon/SvgIcon.vue';
import { SvgIconSize } from 'ewi-ui/components/1-atoms/Icon/SvgIcon/SvgIcon.vue';

export type IconTheme =
  | 'dark'
  | 'light'
  | 'transparent'
  | 'green'
  | 'blue'
  | 'black';
export type RoundIconSize = 'xxs' | 'xs' | 'sm' | 'md' | 'lg' | '';
export type IconStyle = 'circle' | 'square' | 'simple' | 'none';
export type IconBorder = 'black' | 'none';

export interface RoundIconProps {
  icon: string;
  theme?: IconTheme;
  iconSize?: SvgIconSize;
  size?: RoundIconSize;
  iconStyle?: IconStyle;
  border?: IconBorder;
}

const props = withDefaults(defineProps<RoundIconProps>(), {
  icon: '',
  theme: 'light',
  size: '',
  iconSize: '',
  iconStyle: 'circle',
  border: 'none',
});

const classes = computed(() => ({
  roundicon: true,
  [`roundicon__${props.theme}`]: true,
  [`roundicon__${props.size}`]: true,
  [`roundicon__${props.iconStyle}`]: true,
  [`roundicon__${props.border}`]: true,
}));

const icon = computed(() => props.icon);
</script>
